module.exports = __webpack_public_path__ + "media/images/sp/articles/report_temp_03-6385adfdd97dee1c7a95b8aaf786ba7f.webp";